<template>
    <div class="contact">
        <div class="heading4">
            Email and Socials
        </div>
        <div class="content">
            <div class="box">
                <div class="sect">
                    For More Info
                </div>
            <SocialsPage/>
            </div>
            <div class="box">
                <div class="sect">Or Send Me An Email</div>
                <EmailFormPage/>
            </div>
        </div>
    </div>
</template>
<script>
import EmailFormPage from './EmailFormPage.vue';
import SocialsPage from './SocialsPage.vue';

export default{
    components:{
        EmailFormPage, SocialsPage
    }
}
</script>
<style scoped>

.sect{
    color:var(--blue);
    font-family: var(--heading);
    font-size: 1.2rem;
    margin-bottom: 1rem;
}

    
    .contact{
        padding:2rem;
    }

   
    
    
    .box{
        flex:1;
    }

    .content{
        margin-top: 2rem;
        display:flex;
       
    }

    @media(max-width:768px){
        .content{
            flex-direction: column;
        }

        .contact{
        padding:1rem;
    }

    .box{
        margin-bottom:2rem;
    }
    }
</style>